import React from 'react';
import { Chip } from '@mui/material';
import { TOUCHPOINT_OPTIONS } from './constants/conversationTemplateConstants';

const TOUCHPOINT_STYLE = {
  securelink: { bgcolor: '#1e88e5', color: '#fff' }, // blue
  'pre-visit': { bgcolor: '#00897b', color: '#fff' }, // teal
  'post-discharge': { bgcolor: '#8e24aa', color: '#fff' }, // purple
  'medication-review': { bgcolor: '#fb8c00', color: '#fff' }, // orange
  'symptom-followup': { bgcolor: '#3949ab', color: '#fff' }, // indigo
  targeted: { bgcolor: '#6a1b9a', color: '#fff' }, // deep purple — standalone dispatch
};

/**
 * @param {{ value: string }} props
 */
const TouchpointBadge = ({ value }) => {
  const opt = TOUCHPOINT_OPTIONS.find((o) => o.value === value);
  const label = opt?.label || value || 'Unknown';
  const style = TOUCHPOINT_STYLE[value] || { bgcolor: 'grey.500', color: '#fff' };
  return (
    <Chip
      size="small"
      label={label}
      variant="filled"
      sx={{ height: 22, fontSize: '0.7rem', ...style }}
    />
  );
};

export default TouchpointBadge;
